import React from 'react';
import { CheckIcon } from 'lucide-react';
interface Option {
  value: string;
  label: React.ReactNode | string;
  description?: string;
}
interface RadioGroupProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  columns?: 1 | 2 | 3;
}
export function RadioGroup({
  options,
  value,
  onChange,
  className = '',
  columns = 1
}: RadioGroupProps) {
  const gridCols = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3'
  };
  return <div className={`grid gap-3 ${gridCols[columns]} ${className}`} data-id="element-754" data-mp="6k9p685di9qa">
      {options.map(option => {
      const isSelected = value === option.value;
      return <button key={option.value} type="button" onClick={() => onChange(option.value)} className={`relative flex flex-col items-start p-4 text-left transition-all duration-200 border-2 rounded-xl w-full ${isSelected ? 'border-[#007AFF] bg-[#F0F7FF] shadow-[inset_0_0_0_1px_#007AFF]' : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-755" data-mp="fe4lqrsfirub">
            <div className="flex items-center justify-between w-full" data-id="element-756" data-mp="3kitf8c8mu7f5">
              <span className={`font-semibold text-sm transition-colors duration-200 ${isSelected ? 'text-[#007AFF]' : 'text-gray-900'}`} data-id="element-757" data-mp="3ghhmhxugp62q">
                {option.label}
              </span>
              <div className={`flex items-center justify-center w-5 h-5 rounded-full border-2 flex-shrink-0 ml-3 transition-all duration-200 ${isSelected ? 'border-[#007AFF] bg-[#007AFF]' : 'border-gray-300'}`} data-id="element-758" data-mp="c2q94ax64qsx">
                {isSelected && <CheckIcon className="w-3 h-3 text-white" data-id="element-759" data-mp="3uhsgh9r2j0s4" />}
              </div>
            </div>
            {option.description && <span className={`text-xs mt-1.5 transition-colors duration-200 ${isSelected ? 'text-[#005FCC]' : 'text-gray-500'}`} data-id="element-760" data-mp="vstu0lg85t72">
                {option.description}
              </span>}
          </button>;
    })}
    </div>;
}